import React from 'react';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import AnimalManagementTable from '../components/AnimalManagementTable';
import { Link } from '@reach/router';
import { Level } from 'bloomer/lib/components/Level/Level';
import { Button } from 'bloomer/lib/elements/Button';
import { Icon } from 'bloomer/lib/elements/Icon';
import Spacer from '../elements/Spacer';
import { LevelRight } from 'bloomer/lib/components/Level/LevelRight';
import { LevelItem } from 'bloomer/lib/components/Level/LevelItem';
import MarginlessTitle from '../elements/MarginlessTitle';

const ManageAnimals = (props: { path: string }) => {
  return (
    <Container>
      <Box>
        <Level>
          <MarginlessTitle isSize={1} id="manageAnimalsHeading">
            Manage Animals
          </MarginlessTitle>
          <LevelRight>
            <LevelItem>
              <Link to="/manageAnimals/locations">
                <Button isColor="primary">
                  <Icon isSize="small" className="fa fa-compass" /> <Spacer>Manage Locations</Spacer>
                </Button>
              </Link>
            </LevelItem>
            <LevelItem>
              <Link to="/manageAnimals/addAnimal">
                <Button isColor="primary">
                  <Icon isSize="small" className="fa fa-plus" /> <Spacer>Add new animal</Spacer>
                </Button>
              </Link>
            </LevelItem>
          </LevelRight>
        </Level>
        <AnimalManagementTable />
      </Box>
    </Container>
  );
};

export default ManageAnimals;
